'use strict';

var ngModule = 'frontend.components';

require('angular-upload');
require('angular')
  .module(ngModule, [
    require('angular-route'),
    require('angular-cookies'),
    require('./cn-head'),
    'lr.upload'
  ])
  .component('buttonSpinner', require('./button-spinner'))
  .component('djangoForm', require('./django-form'))
  .component('navigationBar', require('./navigation-bar'))
  .component('cnPdfExport', require('./cn-pdf-export'))
  .component('cnDistributionBox', require('./cn-distribution-box'))
  .component('cnDistributionBar', require('./cn-distribution-bar'))
  .component('cnMail', require('./cn-mail'))
  .component('cnMovieButton', require('./cn-movie-button'))
  .component('cnTable', require('./cn-table'))
  .component('cnInviteForm', require('./cn-invite-form'))
  .component('cnInviteImportInstructions', require('./cn-invite-import-instructions'))
  .component('cnRoundForm', require('./cn-round-form'))
  .component('cnFileUpload', require('./cn-file-upload'))
  .component('cnTranspireForm', require('./cn-transpire-form'))
  .component('cnQuestionnaireTextArea', require('./cn-questionnaire-text-area'))
  .component('cnSummaryForm', require('./cn-summary-form'))
  .component('cnQuestionnaireWizard', require('./cn-questionnaire-wizard'))
  .component('cnQuestionnairePager', require('./cn-questionnaire-pager'))
  .component('cnQuestionnaireChoices', require('./cn-questionnaire-choices'))
  .component('cnAgreementAnswer', require('./cn-agreement-answer'))
  .component('cnLogin', require('./cn-login'))
  .component('cnHelpText', require('./cn-help-text'))
  .component('cnAutosaver', require('./cn-autosaver'))
  .provider('$navigation', require('./navigation-bar/provider'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/index.js
 ** module id = 27
 ** module chunks = 0
 **/